const myAdsPageStyles = {
	container: 'flex flex-1 flex-col bg-white',
	content: 'mx-auto w-full max-w-[856px] flex-1 px-[8px] pt-10 pb-[121px]',

	header: 'flex items-center justify-between mb-10',
	title: 'text-title-lg font-bold text-neutral-low-dark leading-[1.3]',

	tabsSection: 'mb-6',

	adsList: 'flex flex-col gap-6',

	createButtonWrapper: 'my-ads-create-btn',
	modalDescription: 'text-sm text-[#2e2e3a] leading-[1.4] font-[Figtree,sans-serif]'
} as const;

export { myAdsPageStyles };
